import React, { useMemo } from 'react';
import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { picklistApi } from 'api';

import { getPicklistDetailItemsColumns } from 'constants/picklist';

const PicklistProducts = ({ picklistId }) => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const columns = useMemo(
    () => getPicklistDetailItemsColumns(tenant, warehouse),
    [tenant, warehouse],
  );
  return (
    <Table
      title={`Picklists #${picklistId} Items`}
      apiService={picklistApi}
      columns={columns}
      fetchConfig={{
        method: 'getProductsOfPicklist',
        enablePagination: true,
      }}
      resourceId={picklistId}
      initialPageSize={25}
      initialFilter={{ tab: 'items' }}
    />
  );
};

export default PicklistProducts;
